<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Parcelamento
            </span>
        </b-button>
		<b-modal
			v-model="showModal"
			id="modalInserirParcelamento"
			hide-footer
		>
			<div slot="modal-title">
				Parcelamento -
				<b-badge variant="warning">Inserir</b-badge>
			</div>
			<parcelamento-form
				tipoOperacao="i"
				:investimento="investimento"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterParcelamentosAtualizados="$emit('obterParcelamentosAtualizados')"
			></parcelamento-form>
		</b-modal>
    </div>
</template>

<script>
import ParcelamentoForm from './ParcelamentoForm'

export default {
	components: {
		ParcelamentoForm
	},

	props: {
		investimento: {
			type: Object,
			default: () => ({})
		}
	},
	
	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
